









































































import { Component, Vue } from 'vue-property-decorator';
import CmsBlock from '@/components/Cms/Block.vue';
import payment from '@/store/modules/payment';
import user from '@/store/modules/user';
import store from '@/store';
import { HipayTokenizedCard } from '@/store/models';

@Component({
  components: {
    CmsBlock,
  },
})
export default class HipayCard extends Vue {
  private mounted() {
    const hipayConfig = store.state.options.payment.hipayConfig;
    if (hipayConfig.use_hostedfields) {
      payment.unregisterMethod('hipay').then(() => {
        payment.registerMethod({ methodCode: 'hipay', params: hipayConfig });
      });
    }
    if (this.tokenizedCards.length > 0) {
      payment.additionalData.hipay_tokenization.tokenId = this.tokenizedCards[0].token_id;
    }
  }

  get isLogged(): boolean {
    return user.isLoggedin;
  }

  get useHostedFields(): boolean {
    return store.state.options.payment.hipayConfig.use_hostedfields;
  }

  get tokenizedCards(): HipayTokenizedCard[] {
    return user.customer.extension_attributes.hipay_tokenized_cards;
  }

  get hipayAdditionalData(): any {
    return payment.additionalData.hipay_tokenization;
  }

  private getCcIcon(cardBrand: string): any {
    const allcards = store.state.options.payment.cc_icons;
    const usecards = [];
    if (allcards) {
      usecards.push(allcards.AE);
      usecards.push(allcards.VI);
      usecards.push(allcards.MC);
      usecards.push(allcards.MI);
    }

    const found = usecards.find(obj => obj.title.toLowerCase() === cardBrand);
    return found ? found.url : '';

  }

  private checkThis(item: string): any {
    console.log(this.$refs);
  }
}
